import React, { useState, useEffect } from 'react';
import { getDatabase, ref, query, orderByChild, equalTo, onValue } from 'firebase/database';
import { Link } from 'react-router-dom';
import PaymentReceipt from './PaymentReceipt';

const PaymentCallback = () => {
  const [paymentStatus, setPaymentStatus] = useState('pending');
  const [paymentDetails, setPaymentDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showReceipt, setShowReceipt] = useState(false);

  useEffect(() => {
    const tx_ref = sessionStorage.getItem('tx_ref');
    if (!tx_ref) {
      setPaymentStatus('failed');
      setLoading(false);
      return;
    }

    const db = getDatabase();
    const paymentsRef = query(ref(db, 'payments'), orderByChild('tx_ref'), equalTo(tx_ref));

    const unsubscribe = onValue(paymentsRef, (snapshot) => {
      if (snapshot.exists()) {
        snapshot.forEach((childSnapshot) => {
          const payment = childSnapshot.val();
          if (payment.status === 'successful') {
            setPaymentStatus('successful');
            setPaymentDetails(payment);
            sessionStorage.removeItem('tx_ref'); // Clean up session storage
          } else if (payment.status === 'failed') {
            setPaymentStatus('failed');
            sessionStorage.removeItem('tx_ref');
          }
        });
      } else {
        // Keep listening, payment might not have been processed by webhook yet
        setPaymentStatus('pending');
      }
      setLoading(false);
    });

    // Cleanup listener on component unmount
    return () => unsubscribe();
  }, []);

  if (loading) {
    return <div>Verifying payment... Please wait.</div>;
  }

  if (showReceipt) {
    return <PaymentReceipt receipt={paymentDetails} onClose={() => setShowReceipt(false)} />;
  }

  return (
    <div className="container mt-5 text-center">
      {paymentStatus === 'successful' && paymentDetails && (
        <div className="alert alert-success">
          <h2>Payment Successful!</h2>
          <p>Your payment has been confirmed.</p>
          <button className="btn btn-primary" onClick={() => setShowReceipt(true)}>View Receipt</button>
        </div>
      )}
      {paymentStatus === 'failed' && (
        <div className="alert alert-danger">
          <h2>Payment Failed</h2>
          <p>There was an issue with your payment. Please try again.</p>
          <Link to="/payment" className="btn btn-secondary">Go to Payment Page</Link>
        </div>
      )}
      {paymentStatus === 'pending' && (
        <div className="alert alert-warning">
          <h2>Payment Pending</h2>
          <p>Your payment is being processed. This page will update automatically once the payment is confirmed.</p>
        </div>
      )}
    </div>
  );
};

export default PaymentCallback;
